import React from "react";

/**
 * Scrapper Icon Component
 * @description A document with spider web representing web scraping
 */
export const ScrapperIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Document outline */}
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
      fill="white"
      opacity="0.9"
    />
    {/* Corner fold */}
    <path
      d="M14 2v6h6"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Spider web lines - center point */}
    <circle cx="12" cy="14" r="1" fill="white" />
    {/* Radial lines */}
    <line x1="12" y1="14" x2="9" y2="11" stroke="white" strokeWidth="0.8" opacity="0.7" />
    <line x1="12" y1="14" x2="15" y2="11" stroke="white" strokeWidth="0.8" opacity="0.7" />
    <line x1="12" y1="14" x2="9" y2="17" stroke="white" strokeWidth="0.8" opacity="0.7" />
    <line x1="12" y1="14" x2="15" y2="17" stroke="white" strokeWidth="0.8" opacity="0.7" />
    {/* Circular web pattern */}
    <path
      d="M 10 13 Q 10 12 11 12 Q 12 12 12 13"
      stroke="white"
      strokeWidth="0.6"
      fill="none"
      opacity="0.6"
    />
    <path
      d="M 12 13 Q 12 12 13 12 Q 14 12 14 13"
      stroke="white"
      strokeWidth="0.6"
      fill="none"
      opacity="0.6"
    />
  </svg>
);

export default ScrapperIcon;

